import { html, TemplateResult } from 'lit';
import { when } from 'lit/directives/when.js';
import type { UserArea } from './user-area';

export const userAreaTemplate = (self: UserArea): TemplateResult => {
  const authItems = self.authItems?.length
    ? self.authItems
    : [];

  return html`
      <!-- Estado autenticado: avatar + nombre + dropdown -->
      <button
        class="trigger bc-flex bc-align-items-center bc-gap-2"
        @click=${() => self._toggle()}
        aria-haspopup="menu"
        aria-expanded=${String(self.open)}
      >
        <span class="avatar bc-flex bc-justify-content-center bc-align-items-center">
          ${self.initials}
        </span>
        <span class="username">${self.userName || 'Usuario'}</span>
      </button>

      ${self.open ? html`
        <div class="popover" role="menu">
          ${authItems.map(it => html`
            <button class="item" role="menuitem" @click=${() => self._select(it)}>
              ${it.label}
            </button>
          `)}
          <button class="item bc-flex bc-align-items-center bc-justify-content-space-between" role="menuitem" @click=${() => self._select({ id: 'logout', label: 'Cerrar sesión' })}>
              Cerrar sesión
              <em class="icon bc-icon">quit</em>
            </button>
        </div>
      ` : null}
  `;
};
